var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptionBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 95,
    viewBox: "0 0 73 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77299 4.34414C1.1051 18.7959 0.269408 33.3147 0.269247 47.843C0.265844 62.3646 1.09707 76.8767 2.75962 91.322L2.871 92.3051L4.09613 92.4723C25.6485 95.4586 47.5874 95.4586 69.1397 92.4723L70.2312 92.3211L70.3426 91.3419C73.6794 62.4193 73.6794 33.2668 70.3426 4.34414L70.2312 3.36105L69.1397 3.20981C47.5473 0.220753 25.5683 0.220752 3.97585 3.20981L2.88437 3.36105L2.77299 4.34414Z",
    fill: "#EEEEE4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionBg);
export default __webpack_public_path__ + "static/media/optionBg.a681318c7cbb30ee351a073113913360.svg";
export { ForwardRef as ReactComponent };